import * as React from 'react';

interface IProp {
    text: string
}

class SampleTextComponent extends React.Component<IProp, {}> {

    render(): JSX.Element {        
        return (
            <p className="goepik-component-no-margin-bottom">{this.props.text}</p>
        );
    }
};

export default SampleTextComponent;
